module.exports = new __parcel__URL__("first_tab_content_zh-tw.39a78cbc.webp").toString();